export default __webpack_public_path__ + "static/media/right-green-icon.fe204aa8.svg";